
import Options from '@/components/controls/Options.vue';
import Calendar from '@/components/controls/Calendar.vue';
// import Nights from '@/components/controls/Nights.vue';
// import Passengers from '@/components/controls/Passengers.vue';
import {
  defineComponent, computed, reactive, ref,
} from 'vue';
// import { useStore } from 'vuex';
// import { dateFromString } from '../../functions';

export default defineComponent({
  components: {
    Options,
    Calendar,
    // Nights,
    // Passengers,
  },
  props: {
    type: String,
    label: String,
    placeholder: String,
    output: String,
    size: String,
    onSelect: Function,
    afterSelect: Function,
    options: Array,
    selected: [Number, String],
    error: String,
    readonly: { type: Boolean, default: true },
    onInput: Function,
    required: Boolean,

    // calendar
    onDateSelect: Function,
    hasSecondDate: Boolean,
    onSecondDateSelect: Function,
    hasDisabled: { type: Boolean, default: true },
    hasYear: Boolean,
    df: Date,
  },
  setup(props) {
    // const $store = useStore();
    const state = reactive({
      inputValue: '',
      open: false,
      stickToRight: false,
    });

    const classOfType = computed(() => `wtv-form-control-${props.type}`);

    const control = ref({});
    const openOptions = (_: Event, open: boolean | undefined = undefined) => {
      state.open = open !== undefined ? open : !state.open;
      const checkRange = () => {
        if (
          window.innerWidth
            - (control.value as HTMLDivElement).getBoundingClientRect().right
          < 100
        ) { state.stickToRight = true; } else state.stickToRight = false;
      };
      const closeOptions = (e: Event) => {
        // eslint-disable-next-line no-param-reassign
        e = e || window.event;
        if (
          control.value
          && (control?.value as HTMLDivElement).contains(e.target as HTMLElement)
        ) { return false; }

        state.open = false;
        window.removeEventListener('click', closeOptions);
        return false;
      };
      if (state.open) {
        setTimeout(() => window.addEventListener('click', closeOptions), 0);
        checkRange();
      }
    };

    const handleSelect = () => {
      if (props.onSelect) props.onSelect(window.event);
      if (props.afterSelect) props.afterSelect();
      state.open = false;
    };

    const calendar = ref({});
    const handleInput = (e = window.event) => {
      const { value } = e?.target as HTMLInputElement;
      if (props.onInput) props.onInput();
      state.inputValue = value;
      if (props.type === 'datepicker' && value.length === 10) {
        state.open = false;
        return;
      }
      state.open = true;
    };

    return {
      state,
      control,
      calendar,
      openOptions,
      handleSelect,
      handleInput,
      classOfType,
    };
  },
});
